export default {
  lang: {
    choose: '语言/Language',
    zhcn: '简体中文',
    zhtw: '繁體中文',
    en: 'English',
    es: 'Español',
    ru: 'Русский',
    de: 'Deutsch',
    changeok: '語言切換成功！'
  },
  btn: {
    ok: '確 定',
    cancel: '取消',
    cont: '繼續'
  },
  menu: {
    upload: '上傳',
    newfolder: '新建文件夾',
    del: '刪除',
    up: '上級目錄',
    refresh: '刷新',
    dfu: 'DFU',
  },
  status: {
    connected: '已連接，版本： ',
    version: '版本：',
    mac: 'MAC 地址： ',
    loading: '加載中…',
  },
  conn: {
    connect: '連接',
    connecting: '連接中…',
    disconnect: '斷開',
    consuccess: '已成功連接到MigFlash!',
    disconnected: 'MigFlash已經斷開連接!',
    connfailed: 'MigFlash連接失敗!'
  },
  labels: {
    name: '文件',
    size: '大小',
    type: '類型',
    remark: '備註'
  },
  contxmenu: {
    del: '刪除…',
    rename: '重命名…',
    prop: '元信息…',
    format: '格式化…'
  },
  properties: {
    title: '特性',
    remark: '備註',
    entermsg: '請輸入備註',
    attrib: '屬性',
    hide: '隱藏',
    errupdate: '更新備註失敗',
    remarktoolong: '備註最大只能是90字節，即90個字符或30個漢字！（當前: ',
    remarktoolongend: ' 字節）'
  },
  upload: {
    title: '上傳',
    drag: '將文件拖到此處，或 ',
    click: '點擊上傳',
    maxsize: '文件路徑總長度不能超過63個字節，超過部分會被截斷。',
    maxname: '文件名不能超過47個字節，超過部分會被截斷。',
    closetitle: '確認關閉？',
    closemessage: '關閉將清空上傳記錄。',
    errupload: '上傳失敗'
  },
  format: {
    title: '格式',
    messrow1a: '是否格式化 ',
    messrow1b: ' ?',
    messrow2: '格式化會刪除所有數據！',
    messrow3: '格式化可能需要10秒鐘左右，請耐心等待。',
    formatok: '格式化完成',
    formaterr: '格式化失敗!'
  },
  del: {
    title: '刪除',
    message: '是否刪除 ',
    messageend: ' ?',
    error: '刪除失敗 ',
    deleteok: '刪除文件成功'
    },
  dfumode: {
    title: 'DFU 模式',
    startconfirm: '是否進入DFU模式?',
    updateconfirm: '進入DFU模式成功，是否打開DFU升級頁面？',
    updatetitle: '提示'
  },
  oldfirm: {
    title: '升級提示',
    message: '您設備的固件版本過低，請更新最新版本固件再使用上傳功能'
  },
  newfolder: {
    title: '新建文件夾',
    message: '請輸入文件夾名',
    newfoldererr: '創建文件夾失敗 '
  },
  rename: {
    title: '改名',
    message: '請輸入新的文件名 ',
    errrename: '重命名失敗 ',
    nametoolong: '文件路徑最大不能超過63個字節',
    pathtoolong: '文件名最大不能超過47個字節'
  },
  drive: {
    message: '(磁盤不可用[錯誤碼: ',
    messageend: '])'
    }
}


// WEBPACK FOOTER //
// ./src/i18n/zh_TW.js